import { defineMessages } from '../define';

export const logs = defineMessages({
  en: {
    'logs.title': 'Logs',
    'logs.description': 'What the platform is doing right now, streamed as it happens.',
    'logs.searchPlaceholder': 'Search messages…',

    'logs.levelLabel': 'Minimum level',
    'logs.level.debug': 'Debug and above',
    'logs.level.info': 'Info and above',
    'logs.level.warn': 'Warnings',
    'logs.level.error': 'Errors',
    'logs.scopeLabel': 'Filter by scope',

    'logs.follow': 'Follow',
    'logs.followLabel': 'Follow new lines',
    'logs.newLines.one': '{count} new line',
    'logs.newLines.other': '{count} new lines',

    'logs.empty.title': 'Nothing to show',
    'logs.empty.description':
      'No lines match these filters. Lower the level or clear the scope to see more.',
  },
  th: {
    'logs.title': 'บันทึกระบบ',
    'logs.description': 'สิ่งที่ระบบกำลังทำอยู่ตอนนี้ แสดงต่อเนื่องแบบเรียลไทม์',
    'logs.searchPlaceholder': 'ค้นหาข้อความ…',

    'logs.levelLabel': 'ระดับต่ำสุด',
    'logs.level.debug': 'Debug ขึ้นไป',
    'logs.level.info': 'Info ขึ้นไป',
    'logs.level.warn': 'เฉพาะคำเตือน',
    'logs.level.error': 'เฉพาะข้อผิดพลาด',
    'logs.scopeLabel': 'กรองตาม scope',

    'logs.follow': 'ติดตาม',
    'logs.followLabel': 'ติดตามบรรทัดใหม่',
    'logs.newLines.one': 'มี {count} บรรทัดใหม่',
    'logs.newLines.other': 'มี {count} บรรทัดใหม่',

    'logs.empty.title': 'ไม่มีข้อมูลให้แสดง',
    'logs.empty.description': 'ไม่มีบรรทัดที่ตรงกับตัวกรองนี้ ลองลดระดับลงหรือล้าง scope เพื่อดูเพิ่มเติม',
  },
});
